import { VueModule } from '@Foundation/utilities';
import Quiz from './code/Scripts/components/Quiz/Quiz.vue';
import Question from './code/Scripts/components/Quiz/Question.vue';
import QuestionModal from './code/Scripts/components/Quiz/QuestionModal.vue';
import Selection from './code/Scripts/components/Quiz/Selection.vue';
import Control from './code/Scripts/components/Quiz/Control.vue';
import Steps from './code/Scripts/components/Quiz/Steps.vue';
import skincareV2Store from './code/Scripts/components/store';

export default VueModule({
  components: {
    Quiz,
    Question,
    QuestionModal,
    Selection,
    Control,
    Steps
  },
  skincareV2Store
});
